import { ITemplateEditor } from "interfaces";
import {
  DEFAULT_DRAWER_STATE,
  DEFAULT_SECTION_DATA,
} from "constants/TemplateEditor";

export const initialState: ITemplateEditor = {
  section: DEFAULT_SECTION_DATA,
  parameters: {
    standard: {
      adapterId: 0,
      adapterName: "",
      isRepeating: false,
      scriptName: "",
      dataTokens: [],
    },
    repeating: [],
    isLoading: true,
  },
  sections: {
    data: [],
    isLoading: false,
  },
  adapters: {
    data: {
      standard: [],
      repeating: [],
    },
    isLoading: false,
  },
  templateRules: {
    data: {
      templateId: -1,
      ruleExpressions: [],
      rules: [],
      id: "",
    },
    isLoading: false,
    isSaving: false,
  },
  drawerInfo: DEFAULT_DRAWER_STATE,
  previewData: {
    data: [],
    isLoading: false,
  },
  repeatingAdapters: {
    data: [],
    isLoading: false,
  },
  editorSettings: {
    clipboard: undefined,
  },
  templatePreview: {
    data: [],
    isLoading: false,
  },
};
